import { navLinks, type NavLink } from "@/data/main-data";
import { useGetPageSettings } from "./main-hooks";

// Returns the nav links, excluding any toggleable page (identified by `key`)
// that is currently hidden from the dashboard. Links without a `key` are
// always shown. While settings are loading, toggleable links are hidden to
// avoid flashing a link that may be disabled.
export function useVisibleNavLinks(): NavLink[] {
  const { data: settings } = useGetPageSettings();

  return navLinks.filter((link) => {
    if (!link.key) return true;
    if (!settings) return false;
    return settings[link.key];
  });
}
